import React from 'react';
import { labLatest } from '../../content/site';
import { GoBar } from './GoBar';
import styles from './Apps.module.css';

/** 지금 볼 것 한 칸: 가장 최근 실험 */
export const Lab: React.FC = () => (
    <a className={styles.lab} href={labLatest.url}>
        <span className={styles.labNumber}>No. {labLatest.number} / {labLatest.date}</span>
        <span className={styles.labTitle}>{labLatest.title}</span>
        <GoBar label="lab.dkdk.me 열기" />
    </a>
);

export default Lab;
